module.exports = __webpack_public_path__ + "img/bigScreenScan@2x.ee44bf3b.png";